import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Messages } from 'primereact/messages';
import { FileUpload } from 'primereact/fileupload';
import { getFormErrorMessage } from '../../../utils/errors';
import { ModalDialog } from '../../../components/ModalDialog';
import { ButtonAdd } from '../../../components/Buttons';
import { FormInput, FormRow } from '../../../components/form';


export const ImportDialog = forwardRef(({
    isVisible,
    onHide,
    onSubmit,
    msgs
}, ref) => {
    const [processing, setProcessing] = useState(false);
    const refFileInput = useRef(null);

    useImperativeHandle(ref, () => ({
        resetFile() {
            reset({ sql_dump: null });
            refFileInput?.current?.clear();
        }
    }));

    const formId = 'import-database-dialog';

    const {
        control,
        formState: { errors, isSubmitting },
        handleSubmit,
        reset
    } = useForm({
        disabled: processing
    });

    useEffect(() => {
        setProcessing(isSubmitting);
    }, [isSubmitting]);

    useEffect(() => {
        if (!isVisible) {
            reset({ sql_dump: null });
            msgs?.current?.clear();
            refFileInput?.current?.clear();
        }
    }, [isVisible, msgs, reset]);

    return(
        <ModalDialog
            visible={isVisible}
            onHide={onHide}
            header={'Importovat SQL dump'}
            footer={
                <ButtonAdd
                    label='Importovat'
                    type='submit'
                    form={formId}
                    disabled={processing}
                    loading={processing}
                />
            }
            style={{ width: 600 }}
        >
            <Messages ref={msgs} className='flex-center' />

            <form onSubmit={handleSubmit(onSubmit)} id={formId}>
                <FormRow>
                    <FormInput>
                        <Controller
                            name='sql_dump'
                            control={control}
                            rules={{ required: 'Vyberte soubor' }}
                            render={({ field }) => (
                                <FileUpload
                                    name={field.name}
                                    ref={refFileInput}
                                    className='sql-upload'
                                    accept='.sql'
                                    url=''
                                    disabled={processing}
                                    uploadHandler={() => {}}
                                    customUpload
                                    headerTemplate={(options) => {
                                        const { className, chooseButton } = options;

                                        return (
                                            <div className={className}>
                                                {chooseButton}
                                            </div>
                                        );
                                    }}
                                    chooseLabel="Vybrat soubor"
                                    cancelLabel="Zrušit"
                                    emptyTemplate={
                                        <div>
                                            <i className='bi bi-upload'></i>{' '}
                                            <span>
                                                Vyberte soubor nebo ho přetáhněte do tohoto pole.
                                            </span>
                                        </div>
                                    }
                                    onBeforeDrop={(event) => {
                                        const file = event.dataTransfer.files[0];
                                        if (file && !file.name.endsWith('.sql')) {
                                            return false;
                                        }
                                    }}
                                    onSelect={(event) => field.onChange(event.files[0])}
                                    onRemove={() => field.onChange(null)}
                                    onClear={() => field.onChange(null)}
                                />
                            )}
                        />
                        {getFormErrorMessage(errors, 'sql_dump')}
                    </FormInput>
                </FormRow>
            </form>

        </ModalDialog>
    );

});
